import React from 'react';
import { SystemDiagram } from '../components/SystemDiagram';
export function SystemPage() {
  return <div className="fixed inset-0 w-screen h-screen bg-[#0A0F1C] text-slate-200 flex flex-col" data-id="element-2122" data-mp="2s04xam62aojw">
      <header className="shrink-0 pt-8 md:pt-10 pb-4 px-6 text-center" data-id="element-2123" data-mp="2n0jzif2mom8r">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight" data-id="element-2124" data-mp="2i28r88rzejsn">
          {[['H', 'igh'], ['I', 'mpact'], ['R', 'ecruiting'], ['E', 'ngine']].map(([initial, rest]) => <span key={initial} className="inline-block mr-3 last:mr-0" data-id="element-2125" data-mp="3aotfh0d5ufrz">
              <span className="text-[#7FE0C3] text-[1.35em] leading-none" style={{
            textShadow: '0 0 28px rgba(127,224,195,0.45)'
          }} data-id="element-2126" data-mp="35qi94zm2qnei">
                {initial}
              </span>
              <span className="text-slate-300 font-medium" data-id="element-2127" data-mp="1uajrw8gqsv27">{rest}</span>
            </span>)}
        </h1>
      </header>

      {/* Bottom padding reserves the deck's navigation bar, so the board
          auto-fits and centers in the space between the title and the nav. */}
      <div className="flex-1 min-h-0 pb-24 md:pb-28" data-id="element-2128" data-mp="1eq7o0v5ctjsa">
        <div className="h-full" data-id="element-2129" data-mp="10rr6sa9v8avw">
          <SystemDiagram data-id="element-2130" data-mp="10qogo4kdach1" />
        </div>
      </div>
    </div>;
}